export default "__VITE_ASSET__BQbnoXvr__"